import {
  FETCH_DRIVERS_DOCUMENTS_DATA,
  FETCH_DRIVERS_DOCUMENTS_SUCCESS,
  FETCH_DRIVERS_DOCUMENTS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const driversDocuments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DRIVERS_DOCUMENTS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_DRIVERS_DOCUMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DRIVERS_DOCUMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default driversDocuments;
